import React from 'react';
import _ from 'lodash';
import { createTableMultiSort } from 'react-virtualized';
import Alert from './Alert';
import EncounterView from './EncounterView';
import EncounterCSV from './EncounterCSV';
import EncounterList from './EncounterList';
import EncounterPatient from './EncounterPatient';
import MessageSendDialog from './MessageSendDialog';

const DatePicker = require('react-bootstrap-date-picker');
const Api = require('./Config');

import moment from 'moment';

const getDaysDiff = (day) => {
  const tm = new Date();
  tm.setDate(tm.getDate() + day);
  return moment(tm).format('YYYY-MM-DDTHH:mm:ss');
};

export default class EncounterReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      encounters: null,
      sendMessage: null,
      from_date: getDaysDiff(-30),
      till_date: getDaysDiff(0),
      filters: {},
      esViewShow: false,
      esViewItem: {
        title: '',
        PMHID: null,
        jid: null,
        lang: '',
      },
      patientShow: false,
      patientItem: {
        ref: '',
        patientId: null,
      },
      allStatus: [],
      allJourneyNames: [],
      allApps: [],
      startIdx: 0,
      endIdx: 50,
      maxRows: 999999,
      oldEncounterMaxId: null,
      newEncounterMaxId: null,
      isLoading: false,
      queryAmount: 100,
    };

    // Infinite Loader
    this.loadMore = this.loadMore.bind(this);
    this.getMoreHl7Reviews = this.getMoreHl7Reviews.bind(this);

    // Filter stuff
    this.resetList = this.resetList.bind(this);
    this.getAllJourneyNames = this.getAllJourneyNames.bind(this);

    // Sort
    this.sort = this.sort.bind(this);
    this.sortState = createTableMultiSort(this.sort);

    // Note Modal
    this.onNoteSave = this.onNoteSave.bind(this);

    // Status
    this.handleStatusChange = this.handleStatusChange.bind(this);

    // Send Message
    this.onMailClick = this.onMailClick.bind(this);
    this.doSendMessage = this.doSendMessage.bind(this);

    // Encounter View
    this.onESViewClick = this.onESViewClick.bind(this);
  }

  componentDidMount() {
    Api.getAllReviewStatus(localStorage.getItem('app_code'))
      .then((allStatus) => {
        this.setState({ allStatus });
      })
      .catch((err) => {
        console.log(err);
      });

    this.getHl7Reviews();

    this.interval = setInterval(() => {
      this.getNewHl7Reviews({ startIdx: 0, endIdx: 100 });
    }, 1000 * 60);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getHl7Reviews() {
    if (this.state.from_date == null || this.state.till_date == null) {
      alert('Valid Date Range required!.');
      return;
    }

    this.setState({ isLoading: true });

    if (this.state.endIdx > this.state.maxIdx) this.state.endIdx = this.state.maxIdx;

    // Other pre-functions
    this.getAllJourneyNames()
      .then(() => {
        Api.getHl7Reviews({
          p_from_date: this.state.from_date,
          p_till_date: this.state.till_date,
          startIdx: this.state.startIdx,
          queryAmount: this.state.queryAmount,
          filter: this.state.filters,
        })
          .then((data) => {
            // get the max id in the list
            const maxId = _.max(_.map(data.encounters, (a) => parseInt(a.id)));
            const distinctApps = [..._.uniq(this.state.allApps.concat(_.map(data.encounters, 'app_id')))];

            this.setState({
              encounters: data.encounters,
              oldEncounterMaxId: maxId,
              newEncounterMaxId: maxId,
              maxRows: data.no_of_rows,
              allApps: distinctApps,
              isLoading: false,
            });
          })
          .catch((error) => {
            console.log('Error getting encounters: ' + error);
          });
      })
      .catch((error) => {
        console.log('Error getting journey names: ' + error);
      });
  }

  async getAllJourneyNames() {
    if (this.state.from_date == null || this.state.till_date == null) {
      alert('Valid date range is required.');
      return;
    }

    const data = await Api.getAllHl7JourneyNames({
      p_from_date: this.state.from_date,
      p_till_date: this.state.till_date,
    });

    let { journies } = data;

    if (typeof journies !== typeof []) return;

    let JIDs = journies.map((j) => j.JID);
    let order = {};

    JIDs.forEach((a, b) => {
      order[a] = b;
    });

    journies.sort((a, b) => {
      return order[a.JID] - order[b.JID];
    });
    journies = journies.map((j) => j.journey_name);

    this.setState({ allJourneyNames: journies });
  }

  loadMore() {
    this.state.startIdx = this.state.queryAmount + this.state.startIdx;

    if (this.state.maxRows > this.state.startIdx)
      this.getMoreHl7Reviews({ startIndex: this.state.startIdx, queryAmount: this.state.queryAmount });
    else return;

    return new Promise((resolve, _reject) => {
      this.promiseResolve = resolve;
    });
  }

  getMoreHl7Reviews({ startIndex, queryAmount }) {
    console.log('Getting more encounters');
    if (this.state.from_date == null || this.state.till_date == null) {
      alert('Valid Date Range required!.');
      return;
    }

    if (this.state.endIdx > this.state.maxIdx) this.state.endIdx = this.state.maxIdx;

    Api.getHl7Reviews({
      p_from_date: this.state.from_date,
      p_till_date: this.state.till_date,
      startIdx: startIndex,
      queryAmount,
      filter: this.state.filters,
      maxFilter: {
        max_id: this.state.oldEncounterMaxId,
        is_new: false,
      },
    })
      .then((data) => {
        const distinctApps = [..._.uniq(this.state.allApps.concat(_.map(data.encounters, 'app_id')))];
        this.setState({
          encounters: this.state.encounters.concat(data.encounters),
          allApps: distinctApps,
        });
        this.promiseResolve();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getNewHl7Reviews({ startIndex, queryAmount }) {
    console.log('Getting new encounters');
    if (this.state.from_date == null || this.state.till_date == null) {
      alert('Valid Date Range required!.');
      return;
    }

    Api.getHl7Reviews({
      p_from_date: this.state.from_date,
      p_till_date: this.state.till_date,
      startIdx: startIndex,
      queryAmount,
      filter: this.state.filters,
      maxFilter: {
        max_id: this.state.newEncounterMaxId,
        is_new: true,
      },
    })
      .then((data) => {
        if (data.encounters.length > 0) {
          let newEncounters = [...data.encounters, ...this.state.encounters];

          // order new items into the existing list
          newEncounters = _.orderBy(
            newEncounters,
            ['diff_date', 'alert', 'need_help_answer_value', 'inactive_sort'],
            ['desc', 'desc', 'asc', 'desc']
          );

          // update max id
          let maxId = _.max(_.map(data.encounters, (a) => parseInt(a.id)));
          this.setState({ newEncounters: newEncounters, newEncounterMaxId: maxId, maxRows: data.no_of_rows });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  resetList() {
    this.setState({ startIdx: 0 });
    this.getHl7Reviews();
  }

  sort({ sortBy, sortDirection }) {
    const dirs = [];
    _.each(sortBy, (a) => {
      dirs.push(sortDirection[a].toLowerCase());
    });

    this.setState({ sortBy, sortDirection, encounters: _.orderBy(this.state.encounters, sortBy, dirs) });
  }

  async doSendMessage(title, message, link, category_id) {
    if (title.trim == '') {
      this.alert.open('Error', 'Empty title or message found');
      return false;
    }

    const { t_code } = this.state.sendMessage;
    this.setState({ sendMessage: null });

    try {
      const response = await Api.sendMessageToTCode(t_code, title, message, link, category_id);
      if (response.SUCCESS === false) {
        this.alert.open('Error', `${response.ERROR}`);
      } else {
        this.alert.open('Sent', 'Message Sent');
      }
    } catch (err) {
      this.alert.open('Error', `${err}`);
    }

    return true;
  }

  onNoteSave(item) {
    if (item) {
      const newEncounters = this.state.encounters.map((encItem) => {
        if (encItem.PMHID === item.PMHID) {
          encItem.note = item.note;
        }
        return encItem;
      });
      this.setState({ encounters: newEncounters });
    }
  }

  onESViewClick(item) {
    this.setState({ esViewShow: true, esViewItem: item });
  }

  onMailClick(item) {
    this.setState({ sendMessage: item });
  }

  /********************************************************
   * Status Functions
   ********************************************************/

  handleStatusChange(pmhid, status) {
    const newEncounters = this.state.encounters.map((encItem) => {
      if (encItem.PMHID === pmhid) {
        encItem.current_status = status;
      }
      return encItem;
    });

    this.setState({ encounters: newEncounters });
  }

  render() {
    if (this.state.encounters === null) {
      return null;
    }

    let btnExtraClass = '';
    if (this.state.isLoading) {
      btnExtraClass += 'disabled';
    }

    return (
      <div>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ maxWidth: 1140 }}>
            Date Range
            <div className="row">
              <div className="col-sm-3">
                From
                <DatePicker
                  dateFormat="MM/DD/YYYY"
                  value={this.state.from_date}
                  onChange={(e) => {
                    this.state.from_date = e;
                    this.resetList();
                  }}
                />
              </div>
              <div className="col-sm-3">
                To
                <DatePicker
                  dateFormat="MM/DD/YYYY"
                  value={this.state.till_date}
                  onChange={(e) => {
                    this.state.till_date = e;
                    this.resetList();
                  }}
                />
              </div>
              <div
                className="sm-6"
                style={{
                  marginTop: 20,
                  marginLeft: 10,
                  marginBottom: 10,
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginRight: 20,
                }}
              >
                <button
                  onClick={() => {
                    this.setState({ filters: {} });
                    this.resetList();
                  }}
                  type="button"
                  className={'btn btn-primary ' + btnExtraClass}
                >
                  Refresh
                </button>
                <EncounterCSV
                  from_date={this.state.from_date}
                  till_date={this.state.till_date}
                  filters={this.state.filters}
                />
              </div>
            </div>
            <EncounterList
              encounters={this.state.encounters}
              allJourneyNames={this.state.allJourneyNames}
              allStatus={this.state.allStatus}
              allApps={this.state.allApps}
              maxRows={this.state.maxRows}
              loadMore={this.loadMore}
              onNoteSave={this.onNoteSave}
              onESViewClick={this.onESViewClick}
              onMailClick={this.onMailClick}
              onPatientClick={(item) => {
                this.setState({ patientShow: true, patientItem: item });
              }}
              onStatusChange={this.handleStatusChange}
              onFilterChange={(item) => {
                this.setState({ filters: item });
                this.resetList();
              }}
              sortState={this.sortState}
              tableStyle={{ marginBottom: 100 }}
              role={this.props.userObj.role}
            />
          </div>
        </div>
        <Alert
          ref={(ref) => {
            this.alert = ref;
          }}
        />
        <EncounterView
          show={this.state.esViewShow}
          title={this.state.esViewItem.title}
          PMHID={this.state.esViewItem.PMHID}
          jid={this.state.esViewItem.jid}
          lang={this.state.esViewItem.lang}
          onClose={() => {
            this.setState({ esViewShow: false });
          }}
        />
        <EncounterPatient
          show={this.state.patientShow}
          patientRef={this.state.patientItem.ref}
          patientId={this.state.patientItem.patientId}
          allStatus={this.state.allStatus}
          onESViewClick={this.onESViewClick}
          onMailClick={this.onMailClick}
          onNoteSave={this.onNoteSave}
          onStatusChange={this.handleStatusChange}
          onClose={() => {
            this.setState({ patientShow: false });
          }}
          role={this.props.userObj.role}
        />
        {this.state.sendMessage && (
          <MessageSendDialog
            app_id={this.state.sendMessage.app_code}
            t_code={this.state.sendMessage.t_code}
            sendAction={this.doSendMessage}
            onClose={() => {
              this.setState({ sendMessage: null });
            }}
          />
        )}
      </div>
    );
  }
}
